export default "__VITE_ASSET__a0a880a6__"